function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 208.45 97"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M143.84 94.71c-.35 0-.71-.08-1.03-.25a2.28 2.28 0 0 1-1.25-2.04V69.6H95.41c-1.26 0-2.28-1.02-2.28-2.28V29.67c0-.61.24-1.19.67-1.61a2.28 2.28 0 0 1 1.61-.67h46.15V4.57c0-.86.48-1.65 1.25-2.04.33-.17.68-.25 1.03-.25.48 0 .95.15 1.35.44l60.04 43.93c.59.43.94 1.11.94 1.84s-.35 1.41-.94 1.84l-60.04 43.93c-.4.29-.87.44-1.35.44Z",
  style: {
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m143.84 4.57 60.04 43.93-60.04 43.93v-25.1H95.4V29.67h48.44zm0-4.57c-.71 0-1.41.16-2.07.49-1.53.78-2.5 2.35-2.5 4.07V25.1H95.4c-2.52 0-4.57 2.05-4.57 4.57v37.65c0 2.52 2.05 4.57 4.57 4.57h43.87v20.54c0 1.72.97 3.29 2.5 4.07.65.33 1.36.49 2.07.49.95 0 1.9-.3 2.7-.88l60.04-43.93c1.18-.86 1.87-2.23 1.87-3.69s-.69-2.83-1.87-3.69L146.54.88c-.8-.58-1.75-.88-2.7-.88",
  style: {
    fill: "#999",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.97,
  height: 17.97,
  x: 0,
  y: 78.38,
  style: {
    fill: "#999",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.97,
  height: 17.97,
  x: 28.8,
  y: 78.38,
  style: {
    fill: "#999",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.97,
  height: 17.97,
  x: 57.6,
  y: 78.38,
  style: {
    fill: "#999",
    strokeWidth: 0
  }
}));
export default SvgArrowRight;